import gql from "graphql-tag";

const getPropieties = gql`
  query($periodo: String!, $institucionId: String){
    creditos_sub_calculos(periodo: $periodo) {
      adicionales(institucionID: $institucionId) {
        periodo
        propiedades
      }
    }
  }
`;
const setLimites = gql`
  mutation Mutation($periodo: DateTime!, $propiedades: CreditPropertiesInput!, $institucionId: String) {
  update_creditos_propiedades_adicionales(periodo: $periodo, propiedades: $propiedades, institucionID: $institucionId) {
    periodo
    propiedades
  }
}
`;
const setLimitesM = gql`
  mutation Update_asientos_propiedades_adicionales($propiedades: AsientosPropertiesInput!, $periodo: DateTime!, $institucionId: String) {
    update_asientos_propiedades_adicionales(propiedades: $propiedades, periodo: $periodo, institucionID: $institucionId) {
      periodo
      propiedades
    }
  }
`;
const getPeriodosAT = gql`
 query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
    }
  }
`;
const getInfoPerspectives = gql`
query Query($periodo: String!) {
  creditsResultsByPerspective(periodo: $periodo) {
    tipoNormativa {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
        conteoTotalCreditosConFechaFormalizacion
        conteoTotalCreditosUnicos
      }
    }
    genero {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    bandaMontoOtorgado {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    rangoPlazoOtorgado {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    producto {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    tipoGarantia {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    sucursal {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    region {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    tipoPersona {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    departamento {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    estadoCivil {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    formacionAcademica {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
    nivelAprobacion {
      code
      description
      results {
        conteoTotalCreditos
        sumatoriaMontoOtorgado
        sumatoriaAmortizacionCuota
        saldoCuentasEnMora {
          vigentes {
            cuentas
            totalAmortizacionCuota
          }
          vencidos {
            cuentas
            totalAmortizacionCuota
          }
        }
      }
    }
  }
}
`;
const getEvaluaciones = gql`
  query periodos {
    creditos_periodosCargados
  }
`;
const getDatosMontos = gql`
  query datosMontos($periodo: String!) {
    creditos_sub_calculos(periodo: $periodo) {
      CRE_14 {
        limits {
          max
          min
        }
        value
      }
      CRE_15 {
        limits {
          max
          min
        }
        value
      }
      CRE_16 {
        limits {
          max
          min
        }
        value
      }
      CRE_17 {
        limits {
          max
          min
        }
        value
      }
      CRE_18 {
        limits {
          max
          min
        }
        value
      }
      CRE_19 {
        limits {
          max
          min
        }
        value
      }
      CRE_20 {
        limits {
          max
          min
        }
        value
      }
      CRE_21 {
        limits {
          max
          min
        }
        value
      }
      CRE_22 {
        limits {
          max
          min
        }
        value
      }
      CRE_23 {
        limits {
          max
          min
        }
        value
      }
      CRE_24 {
        limits {
          max
          min
        }
        value
      }
      CRE_25 {
        limits {
          max
          min
        }
        value
      }
      CRE_26 {
        limits {
          max
          min
        }
        value
      }
      CRE_27 {
        limits {
          max
          min
        }
        value
      }
      CRE_28 {
        limits {
          max
          min
        }
        value
      }
      CRE_29 {
        limits {
          max
          min
        }
        value
      }
      CRE_30 {
        limits {
          max
          min
        }
        value
      }
      CRE_31 {
        limits {
          max
          min
        }
        value
      }
      CRE_32 {
        limits {
          max
          min
        }
        value
      }
      CRE_33 {
        limits {
          max
          min
        }
        value
      }
      CRE_34 {
        limits {
          max
          min
        }
        value
      }
      CRE_35 {
        limits {
          max
          min
        }
        value
      }
      CRE_36 {
        limits {
          max
          min
        }
        value
      }
      CRE_37 {
        limits {
          max
          min
        }
        value
      }
      CRE_38 {
        limits {
          max
          min
        }
        value
      }
      CRE_39 {
        limits {
          max
          min
        }
        value
      }
      CRE_40 {
        limits {
          max
          min
        }
        value
      }
      CRE_41 {
        limits {
          max
          min
        }
        value
      }
      CRE_42 {
        limits {
          max
          min
        }
        value
      }
      CRE_43 {
        limits {
          max
          min
        }
        value
      }
      CRE_44 {
        limits {
          max
          min
        }
        value
      }
      CRE_45 {
        limits {
          max
          min
        }
        value
      }
      CRE_46 {
        limits {
          max
          min
        }
        value
      }
      CRE_47 {
        limits {
          max
          min
        }
        value
      }
      CRE_48 {
        limits {
          max
          min
        }
        value
      }
      CRE_49 {
        limits {
          max
          min
        }
        value
      }
      CRE_50 {
        limits {
          max
          min
        }
        value
      }
      CRE_51 {
        limits {
          max
          min
        }
        value
      }
      CRE_52 {
        limits {
          max
          min
        }
        value
      }
      CRE_53 {
        limits {
          max
          min
        }
        value
      }
      CRE_54 {
        limits {
          max
          min
        }
        value
      }
      CRE_55 {
        limits {
          max
          min
        }
        value
      }
      CRE_56 {
        limits {
          max
          min
        }
        value
      }
      CRE_57 {
        limits {
          max
          min
        }
        value
      }
      CRE_58 {
        limits {
          max
          min
        }
        value
      }
      CRE_59 {
        limits {
          max
          min
        }
        value
      }
      CRE_60 {
        limits {
          max
          min
        }
        value
      }
      CRE_61 {
        limits {
          max
          min
        }
        value
      }
      CRE_62 {
        limits {
          max
          min
        }
        value
      }
      CRE_63 {
        limits {
          max
          min
        }
        value
      }
      CRE_64 {
        limits {
          max
          min
        }
        value
      }
      CRE_65 {
        limits {
          max
          min
        }
        value
      }
      CRE_66 {
        limits {
          max
          min
        }
        value
      }
      CRE_67 {
        limits {
          max
          min
        }
        value
      }
      CRE_68 {
        limits {
          max
          min
        }
        value
      }
      CRE_69 {
        limits {
          max
          min
        }
        value
      }
      CRE_70 {
        limits {
          max
          min
        }
        value
      }
      CRE_71 {
        limits {
          max
          min
        }
        value
      }
      CRE_72 {
        limits {
          max
          min
        }
        value
      }
      CRE_73 {
        limits {
          max
          min
        }
        value
      }
      CRE_74 {
        limits {
          max
          min
        }
        value
      }
      CRE_75 {
        limits {
          max
          min
        }
        value
      }
      CRE_76 {
        limits {
          max
          min
        }
        value
      }
      CRE_77 {
        limits {
          max
          min
        }
        value
      }
      CRE_78 {
        limits {
          max
          min
        }
        value
      }
      CRE_79 {
        limits {
          max
          min
        }
        value
      }
      CRE_80 {
        limits {
          max
          min
        }
        value
      }
      CRE_81 {
        limits {
          max
          min
        }
        value
      }
      CRE_82 {
        limits {
          max
          min
        }
        value
      }
      CRE_83 {
        limits {
          max
          min
        }
        value
      }
      CRE_84 {
        limits {
          max
          min
        }
        value
      }
      CRE_85 {
        limits {
          max
          min
        }
        value
      }
      CRE_86 {
        limits {
          max
          min
        }
        value
      }
      CRE_87 {
        limits {
          max
          min
        }
        value
      }
      CRE_88 {
        limits {
          max
          min
        }
        value
      }
      CRE_89 {
        limits {
          max
          min
        }
        value
      }
      CRE_90 {
        limits {
          max
          min
        }
        value
      }
      CRE_91 {
        limits {
          max
          min
        }
        value
      }
      CRE_92 {
        limits {
          max
          min
        }
        value
      }
      CRE_93 {
        limits {
          max
          min
        }
        value
      }
      CRE_94 {
        limits {
          max
          min
        }
        value
      }
      CRE_95 {
        limits {
          max
          min
        }
        value
      }
      CRE_96 {
        limits {
          max
          min
        }
        value
      }
      CRE_97 {
        limits {
          max
          min
        }
        value
      }
      CRE_98 {
        limits {
          max
          min
        }
        value
      }
      CRE_99 {
        limits {
          max
          min
        }
        value
      }
      CRE_100 {
        limits {
          max
          min
        }
        value
      }
      CRE_101 {
        limits {
          max
          min
        }
        value
      }
      CRE_102 {
        limits {
          max
          min
        }
        value
      }
      CRE_103 {
        limits {
          max
          min
        }
        value
      }
      CRE_104 {
        limits {
          max
          min
        }
        value
      }
      CRE_105 {
        limits {
          max
          min
        }
        value
      }
      CRE_106 {
        limits {
          max
          min
        }
        value
      }
      CRE_107 {
        limits {
          max
          min
        }
        value
      }
      CRE_108 {
        limits {
          max
          min
        }
        value
      }
      CRE_109 {
        limits {
          max
          min
        }
        value
      }
      CRE_110 {
        limits {
          max
          min
        }
        value
      }
      CRE_111 {
        limits {
          max
          min
        }
        value
      }
      CRE_112 {
        limits {
          max
          min
        }
        value
      }
      CRE_113 {
        limits {
          max
          min
        }
        value
      }
      CRE_114 {
        limits {
          max
          min
        }
        value
      }
      CRE_115 {
        limits {
          max
          min
        }
        value
      }
      CRE_116 {
        limits {
          max
          min
        }
        value
      }
      CRE_117 {
        limits {
          max
          min
        }
        value
      }
      CRE_118 {
        limits {
          max
          min
        }
        value
      }
      CRE_119 {
        limits {
          max
          min
        }
        value
      }
      CRE_120 {
        limits {
          max
          min
        }
        value
      }
      CRE_121 {
        limits {
          max
          min
        }
        value
      }
      CRE_122 {
        limits {
          max
          min
        }
        value
      }
      CRE_123 {
        limits {
          max
          min
        }
        value
      }
      CRE_124 {
        limits {
          max
          min
        }
        value
      }
      CRE_125 {
        limits {
          max
          min
        }
        value
      }
      CRE_126 {
        limits {
          max
          min
        }
        value
      }
      CRE_127 {
        limits {
          max
          min
        }
        value
      }
      CRE_128 {
        limits {
          max
          min
        }
        value
      }
      CRE_129 {
        limits {
          max
          min
        }
        value
      }
      CRE_130 {
        limits {
          max
          min
        }
        value
      }
      CRE_131 {
        limits {
          max
          min
        }
        value
      }
      CRE_132 {
        limits {
          max
          min
        }
        value
      }
      CRE_133 {
        limits {
          max
          min
        }
        value
      }
      CRE_134 {
        limits {
          max
          min
        }
        value
      }
      CRE_135 {
        limits {
          max
          min
        }
        value
      }
      CRE_136 {
        limits {
          max
          min
        }
        value
      }
      CRE_137 {
        limits {
          max
          min
        }
        value
      }
      CRE_138 {
        limits {
          max
          min
        }
        value
      }
      CRE_139 {
        limits {
          max
          min
        }
        value
      }
      CRE_140 {
        limits {
          max
          min
        }
        value
      }
      CRE_141 {
        limits {
          max
          min
        }
        value
      }
      CRE_142 {
        limits {
          max
          min
        }
        value
      }
      CRE_143 {
        limits {
          max
          min
        }
        value
      }
      CRE_144 {
        limits {
          max
          min
        }
        value
      }
      CRE_145 {
        limits {
          max
          min
        }
        value
      }
      CRE_146 {
        limits {
          max
          min
        }
        value
      }
      CRE_147 {
        limits {
          max
          min
        }
        value
      }
      CRE_148 {
        limits {
          max
          min
        }
        value
      }
      CRE_149 {
        limits {
          max
          min
        }
        value
      }
      CRE_150 {
        limits {
          max
          min
        }
        value
      }
      CRE_151 {
        limits {
          max
          min
        }
        value
      }
      CRE_152 {
        limits {
          max
          min
        }
        value
      }
      CRE_153 {
        limits {
          max
          min
        }
        value
      }
      CRE_154 {
        limits {
          max
          min
        }
        value
      }
      CRE_155 {
        limits {
          max
          min
        }
        value
      }
      CRE_156 {
        limits {
          max
          min
        }
        value
      }
      CRE_157 {
        limits {
          max
          min
        }
        value
      }
      CRE_158 {
        limits {
          max
          min
        }
        value
      }
      CRE_159 {
        limits {
          max
          min
        }
        value
      }
      CRE_160 {
        limits {
          max
          min
        }
        value
      }
      CRE_161 {
        limits {
          max
          min
        }
        value
      }
      CRE_162 {
        limits {
          max
          min
        }
        value
      }
      CRE_163 {
        limits {
          max
          min
        }
        value
      }
      CRE_164 {
        limits {
          max
          min
        }
        value
      }
      CRE_165 {
        limits {
          max
          min
        }
        value
      }
      CRE_166 {
        limits {
          max
          min
        }
        value
      }
      CRE_167 {
        limits {
          max
          min
        }
        value
      }
      CRE_168 {
        limits {
          max
          min
        }
        value
      }
      CRE_169 {
        limits {
          max
          min
        }
        value
      }
      CRE_170 {
        limits {
          max
          min
        }
        value
      }
      CRE_171 {
        limits {
          max
          min
        }
        value
      }
      CRE_172 {
        limits {
          max
          min
        }
        value
      }
      CRE_173 {
        limits {
          max
          min
        }
        value
      }
      CRE_174 {
        limits {
          max
          min
        }
        value
      }
      CRE_175 {
        limits {
          max
          min
        }
        value
      }
      CRE_176 {
        limits {
          max
          min
        }
        value
      }
      CRE_177 {
        limits {
          max
          min
        }
        value
      }
      CRE_178 {
        limits {
          max
          min
        }
        value
      }
      CRE_179 {
        limits {
          max
          min
        }
        value
      }
      CRE_180 {
        limits {
          max
          min
        }
        value
      }
      CRE_181 {
        limits {
          max
          min
        }
        value
      }
      CRE_182 {
        limits {
          max
          min
        }
        value
      }
      CRE_183 {
        limits {
          max
          min
        }
        value
      }
      CRE_184 {
        limits {
          max
          min
        }
        value
      }
      CRE_185 {
        limits {
          max
          min
        }
        value
      }
      CRE_186 {
        limits {
          max
          min
        }
        value
      }
      CRE_187 {
        limits {
          max
          min
        }
        value
      }
      CRE_188 {
        limits {
          max
          min
        }
        value
      }
      CRE_189 {
        limits {
          max
          min
        }
        value
      }
    }
  }
`;
const getPropieties2 = gql`
  query($periodo: String!, $institucionId: String){
    creditos_sub_calculos(periodo: $periodo) {
      CRE_14 {
        value
      }
      adicionales(institucionID: $institucionId) {
        periodo
        propiedades
      }
    }
  }
`;
const getPerspectives = gql`
query Query {
  creditsPerspectives
}
`;
const getData = gql`
  query Creditos_sub_calculos($periodo: String!) {
    creditos_sub_calculos(periodo: $periodo) {
      ASI_03 {
        vigentes {
          numeroSocio
          numeroCredito
          esVigente
          amortizacionCuotaSuma
        }
        vencidos {
          numeroSocio
          numeroCredito
          esVigente
          amortizacionCuotaSuma
        }
      }
    }
  }
`;
const getDetalleVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!) {
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;
const getATVarP = gql`
  query DetalleEvaluacionCuenta($idEvaluacion: Int!, $idCuenta: String!) {
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion, idCuenta: $idCuenta) {
      idEvaluacion
      idCuenta
      valor
    }
  }
`;

export {setLimitesM,getATVarP,getDetalleVarTemp,getData,getEvaluaciones, getDatosMontos, setLimites, getPeriodosAT, getPropieties, getPropieties2, getPerspectives, getInfoPerspectives}